import _ from 'lodash'
import Country from './CountryClass.js'

export default class {
  /**
   * Constructor
   */
  constructor () {
    this.countries = []
  }

  /**
   * Return ID
   */
  addCountry (dataRow, $el, $store) {
    this.countries.push(new Country(dataRow, $el, $store))
  }

  /**
   * Return all
   */
  all () {
    return this.countries
  }

  /**
   * Return first result by name
   */
  firstByName (name) {
    return _.find(this.countries, { name: name })
  }

  /**
   * Return first result by year and name
   */
  firstByYearName (year, name) {
    return _.find(this.countries, (c) => {
      return parseInt(c.year) === parseInt(year) && c.name === name
    })
  }

  /**
   * Reset the collection
   */
  reset () {
    this.countries = []
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/CountryRepository.js